// extracted by mini-css-extract-plugin
export default {"innerWrapper":"au-z","tooltipWrapper":"bu-z","icon":"cu-z","tooltip":"du-z","content":"eu-z"};